import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem("paww_token") || sessionStorage.getItem("paww_token"));
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const logout = () => {
    localStorage.removeItem("paww_token");
    sessionStorage.removeItem("paww_token");
    delete axios.defaults.headers.common.Authorization;
    setToken(null);
    setUser(null);
  };

  useEffect(() => {
    if (token) {
      axios.defaults.headers.common.Authorization = `Bearer ${token}`;
      axios
        .get(`${API}/auth/me`)
        .then((r) => setUser(r.data))
        .catch(() => logout())
        .finally(() => setLoading(false));
    } else {
      delete axios.defaults.headers.common.Authorization;
      setLoading(false);
    }
  }, [token]);

  const persist = (data, remember = true) => {
    const store = remember ? localStorage : sessionStorage;
    const other = remember ? sessionStorage : localStorage;
    store.setItem("paww_token", data.token);
    other.removeItem("paww_token");
    axios.defaults.headers.common.Authorization = `Bearer ${data.token}`;
    setToken(data.token);
    setUser(data.user);
  };

  const login = async (email, password, remember = true) => {
    const { data } = await axios.post(`${API}/auth/login`, { email, password });
    persist(data, remember);
    return data.user;
  };
  const register = async (email, password, name, remember = true) => {
    const { data } = await axios.post(`${API}/auth/register`, { email, password, name });
    persist(data, remember);
    return data.user;
  };
  const googleLogin = useCallback(async (session_id) => {
    const { data } = await axios.post(`${API}/auth/google`, { session_id });
    persist(data);
    return data.user;
  }, []);
  const awardPoints = async (action) => {
    if (!localStorage.getItem("paww_token")) return;
    try {
      const { data } = await axios.post(`${API}/points/award`, { action });
      setUser((u) => (u ? { ...u, points_balance: data.points_balance } : u));
    } catch (e) { console.error("Session restore failed:", e); }
  };

  const applyBalance = (points_balance) =>
    setUser((u) => (u ? { ...u, points_balance } : u));

  const deleteAccount = async () => {
    await axios.delete(`${API}/auth/account`);
    logout();
  };

  return (
    <AuthCtx.Provider value={{ token, user, loading, login, register, googleLogin, logout, awardPoints, applyBalance, deleteAccount }}>
      {children}
    </AuthCtx.Provider>
  );
}
